// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-control-label h5[data-v-664553c8] {\n  margin-bottom: 0px;\n}", ""]);
// Exports
module.exports = exports;
